import { Component, Input } from '@angular/core';

@Component({
    selector: 'list-request-times',
    templateUrl: './list-request-times.component.html',
    styles: [`
    :host {
      margin-top: 10px;
      margin-bottom: 10px;
    }
  `],
    standalone: false
})
export class ListRequestTimesComponent {
  @Input() times = [];

  constructor() { }
}
